import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as $ from 'jquery';
import { Subject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ValidationError } from 'core-lib';
import { FormValidationService, FormValidator } from 'core-lib';
@Component({
  selector: 'cli-set-password-modal',
  templateUrl: './set-password-modal.component.html',
  styleUrls: ['./set-password-modal.component.css']
})

export class SetPasswordModalComponent implements OnInit {


  private subject: Subject<string>;

  @Input()
  public id: string;
  @Input()
  public message: string;
  @Input()
  public header: string;

  @Input()
  public password: string;
  public confirmPassword: string;

  @Output()
  public passwordChange: EventEmitter<any> = new EventEmitter();
  public errors: ValidationError[];
  public validator: FormValidator;

  constructor(private formValidationSvc: FormValidationService) {
    this.header = environment.MODAL_HEADER;
    this.validator = this.formValidationSvc.getFormValidator(this);
  }

  ngOnInit() {
  }

  public openModal(): Observable<string> {

    $('#' + this.id).modal();
    this.subject = new Subject<string>();

    this.password = '';
    this.confirmPassword = '';


    return this.subject.asObservable();
  }

  public proceedYes() {
    if (!this.validate()) { return; }

    this.closeModal();

    this.subject.next('Yes');
    this.subject.complete();
  }

  public proceedCancel() {
    this.closeModal();

    this.subject.next('Cancel');
    this.subject.complete();
  }

  public closeModal() {
    $('#' + this.id).modal('hide');
  }

  validate(): boolean {
    this.errors = [];

    this.validator.validateMinLength('password', 'Password', 6);
    this.validator.validateMinLength('confirmPassword', 'Password', 6);

    this.validator.validateRequired('password', 'Password');
    this.validator.validateRequired('confirmPassword', 'Confirm Password');
    
    this.validator.validateCustom('password', 'Passwords don\'t match',
      () => { return this.password != this.confirmPassword; });
    return this.errors.length === 0;
  }

  public error(fieldName: string): string {
    return this.formValidationSvc.getErrorMessage(this, fieldName);
  }

}
